import React from 'react';

type TrainerCalAddProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  label?: string;
};

/** Shared dashed Add control for trainer day grids (Member + Plan Edit). */
export function TrainerCalAdd({
  onClick,
  className = 'twp-cal-add',
  label = 'Add workout',
}: TrainerCalAddProps) {
  return (
    <button type="button" className={className} onClick={onClick}>
      <svg
        width="13"
        height="13"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M12 5v14M5 12h14" />
      </svg>
      {label}
    </button>
  );
}
